// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { DateTime } from 'luxon';

/**
 * Renders a subscription date the way the notice copy reads it, such as
 * "August 31".
 */
export function formatSubscriptionNoticeDate(date: DateTime): string {
  return date.toLocaleString({ month: 'long', day: 'numeric' });
}

/**
 * Builds the subscription expiration copy shown in the banner. The grace period
 * sentences are dropped when no access end date has been set.
 */
export function formatSubscriptionExpirationNotice(
  organizationName: string,
  subscriptionEndDate: DateTime,
  accessEndDate: DateTime | null
): string {
  const expiration = `The ${organizationName} subscription expired on ${formatSubscriptionNoticeDate(subscriptionEndDate)} and has not been renewed.`;

  if (accessEndDate === null) {
    return expiration;
  }

  return `${expiration} Your organization has a grace period until ${formatSubscriptionNoticeDate(accessEndDate)}. Then you will be unable to log in.`;
}
